module.exports = {"540231100":"江嘎镇","540231101":"陈塘镇","540231102":"日屋镇","540231200":"确布乡","540231201":"扎西岗乡","540231202":"多布扎乡","540231203":"定结乡","540231204":"琼孜乡","540231205":"萨尔乡","540231206":"郭加乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540231.json
// module id = 2502
// module chunks = 0